import CancelIcon from '@mui/icons-material/Cancel';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, CircularProgress, Divider, FormControl, IconButton, InputAdornment, InputLabel, List, ListItemButton, ListItemIcon, ListItemText, OutlinedInput, Button } from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAdminUsers } from '../../../hooks/useAdminUsers';

export const UserList = () => {
    const [filter, setFilter] = useState<string>('');

    const { data: users = [], isFetched } = useAdminUsers();
    const navigate = useNavigate();

    const getFilteredUsers = () => {
        if (filter.length > 0) {
            const filterRegex = new RegExp(filter, 'gi');

            return users.filter(({ firstName, lastName, email }) => {
                return `${firstName} ${lastName} ${email}`.match(filterRegex);
            });
        }
        return users;
    };

    const handleSelectedUser = (id: string) => {
        navigate(`/admin/users/${id}`);
    };

    return (
        <Box sx={{ height: '100%', overflow: 'hidden' }}>
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ p: 3, maxWidth: (theme) => theme.breakpoints.values.sm }}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="filter-users">Filter Users</InputLabel>
                        <OutlinedInput
                            id="filter-users"
                            fullWidth
                            label="Filter Users"
                            value={filter}
                            onChange={(event) => setFilter(event.target.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton aria-label={'clear the filter'} edge="end" onClick={() => setFilter('')}>
                                        <CancelIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </Box>
                <Divider />
                <Box sx={{ height: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {!isFetched && <CircularProgress />}
                    {isFetched && (
                        <List sx={{ width: '100%', height: '100%', overflowY: 'scroll', p: 0 }}>
                            {getFilteredUsers().map((user) => {
                                const { _id, firstName, lastName, email, lastLogin } = user;

                                return (
                                    <ListItemButton key={_id.toString()} divider={true} onClick={() => handleSelectedUser(_id.toString())}>
                                        <ListItemText primary={`${firstName} ${lastName}`} secondary={email} />
                                        {lastLogin && (
                                            <ListItemText
                                                sx={{ flex: '0 0 auto', mr: 2, textAlign: 'right' }}
                                                primary="Last Login"
                                                secondary={dayjs(lastLogin).format('MMM D, YYYY h:mm A')}
                                                slotProps={{ primary: { variant: 'caption', color: 'text.secondary' }, secondary: { variant: 'body2' } }}
                                            />
                                        )}
                                        <ListItemIcon>
                                            <NavigateNextIcon />
                                        </ListItemIcon>
                                    </ListItemButton>
                                );
                            })}
                        </List>
                    )}
                </Box>
            </Box>
        </Box>
    );
};
